var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.filteredOptions),function(option){return _c('el-option',{key:option,attrs:{"label":_vm.$tf(option),"value":option}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }